export const WarningConfirmations = {
  ReviewTaskUserSortWillBreak: {
    id: "review-task-user-sort-will-break",
    message: (
      <>
        This action will disrupt the current view. If you wish to return to the same user
        aggregation, cancel the sort.
        <br />
        If you proceed with sorting and need to bring back user aggregation view later, please sort
        by user column.
      </>
    ),
  },
};

export function getWarningConfirmation(id) {
  for (let key in WarningConfirmations) {
    if (WarningConfirmations[key].id === id) {
      return WarningConfirmations[key];
    }
  }
  return null;
}
